/* src/app/bot/ask-question/ask-question.component.scss */
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 96vh;
  --primary: #253b80;
  --primary-light: #eef2ff;
  --bg: #f8fafc;
  --card: #fff;
  --text: #0f172a;
  --text-light: #64748b;
  --border: #e2e8f0;
  background: var(--bg);
}
app-page-header {
  position: sticky;
  top: 0;
  z-index: 100;
  align-items: center;
  justify-content: space-between;
  max-width: 100% !important;
  height: 72px;
  padding: 0 24px;
}
app-page-header .header-left,
app-page-header .header-center,
app-page-header .header-right {
  display: flex;
  align-items: center;
}
app-page-header .header-center {
  flex: 1;
  justify-content: center;
}
app-page-header .header-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 50px;
  border-radius: 14px;
}
app-page-header .header-logo img {
  width: auto;
  height: 32px;
  object-fit: contain;
}
app-page-header .query-toggle {
  display: inline-flex;
  padding: 4px;
}
app-page-header .query-toggle .toggle-item {
  position: relative;
  padding: 4px 22px;
  cursor: pointer;
  border-radius: 999px;
  transition: all 0.25s ease;
}
app-page-header .query-toggle .toggle-item input {
  display: none;
}
app-page-header .query-toggle .toggle-item .toggle-text {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-light);
  transition: color 0.25s ease;
}
app-page-header .query-toggle .toggle-item.active {
  background: var(--primary);
}
app-page-header .query-toggle .toggle-item.active .toggle-text {
  color: #fff;
}
app-page-header .query-toggle .toggle-item:hover:not(.active) {
  background: #f1f5f9;
}
app-page-header .header-right {
  gap: 12px;
}
app-page-header .icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transition: all 0.25s ease;
}
app-page-header .icon-btn i {
  font-size: 18px;
}
app-page-header .icon-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}
.count {
  min-width: 28px;
  height: 28px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f1f5f9;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}
.header-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.query-toggle {
  position: relative;
  min-width: 270px;
  min-height: 48px;
  padding: 4px;
  display: flex;
  align-items: stretch;
  transition: all 0.25s ease;
}
.toggle-item {
  position: relative;
  flex: 1;
  min-width: 0;
  min-height: 38px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 9px;
  color: #64748b;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  transition:
    background 0.22s ease,
    color 0.22s ease,
    box-shadow 0.22s ease;
}
.toggle-item input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}
.toggle-item:hover:not(.active) {
  color: #334155;
  background: rgba(255, 255, 255, 0.55);
}
.toggle-item.active {
  background: #ffffff;
  color: #253b80;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
}
.toggle-item.active .toggle-icon {
  color: #253b80;
  transform: scale(1.03);
}
.toggle-item.active .toggle-description {
  color: #64748b;
}
.toggle-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #94a3b8;
  font-size: 12px;
  transition:
    background 0.22s ease,
    color 0.22s ease,
    transform 0.22s ease;
}
.toggle-item.active .generic-icon {
  color: #f5f3ff;
}
.toggle-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.toggle-text {
  color: inherit;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
}
.toggle-description {
  margin-top: 2px;
  color: #a1aaba;
  font-size: 8px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  transition: color 0.2s ease;
}
.toggle-item:first-child.active {
  color: #f5f3ff;
}
.toggle-item:first-child.active .toggle-icon {
  color: #f5f3ff;
}
.toggle-item:last-child.active {
  color: #f5f3ff;
}
.toggle-item:last-child.active .toggle-icon {
  color: #f5f3ff;
}
.toggle-item:has(input:focus-visible) {
  outline: 2px solid rgba(37, 99, 235, 0.25);
  outline-offset: -1px;
}
@media (max-width: 767px) {
  .query-toggle {
    min-width: 205px;
    min-height: 42px;
    border-radius: 10px;
  }
  .toggle-item {
    min-height: 34px;
    padding: 4px 7px;
    gap: 6px;
    border-radius: 7px;
  }
  .toggle-icon {
    width: 26px;
    height: 26px;
    border-radius: 7px;
    font-size: 10px;
  }
  .toggle-text {
    font-size: 10px;
  }
  .toggle-description {
    display: none;
  }
}
@media (max-width: 480px) {
  .query-toggle {
    min-width: 150px;
    width: 150px;
  }
  .toggle-item {
    padding: 4px 5px;
    gap: 4px;
  }
  .toggle-icon {
    width: 24px;
    height: 24px;
    font-size: 9px;
  }
  .toggle-text {
    font-size: 9px;
  }
}
.main {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.chat-list {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 99.5%;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 30px;
  box-sizing: border-box;
  scroll-behavior: smooth;
}
.chat-list::-webkit-scrollbar {
  width: 6px;
}
.chat-list::-webkit-scrollbar-thumb {
  background: #727578;
  border-radius: 50px;
}
.chat-list app-ai {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.chat-wrapper {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
.empty-state {
  display: flex;
  justify-content: center;
  width: 100%;
}
.empty-state .box {
  max-width: 650px;
  padding: 50px;
  text-align: center;
  background: #fff;
  border-radius: 28px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
}
.empty-state .box h2 {
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
}
.empty-state .box p {
  font-size: 13.5px;
  line-height: 1.7;
  color: var(--text-light);
}
.empty-state .box strong {
  color: var(--primary);
}
.chat-input-wrapper {
  width: 100%;
  max-width: 980px;
  margin: 0 auto;
  padding: 0 16px 14px;
  box-sizing: border-box;
}
.chat-input-container {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  width: 100%;
  min-height: 68px;
  padding: 10px 10px 10px 18px;
  background: #ffffff;
  border: 1px solid #d9dfeb;
  border-radius: 18px;
  box-shadow: 0 2px 6px rgba(37, 59, 128, 0.05), 0 8px 24px rgba(15, 23, 42, 0.05);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
  box-sizing: border-box;
}
.chat-input-container:focus-within {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08), 0 8px 24px rgba(15, 23, 42, 0.08);
}
.input-area {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
}
.message-input {
  width: 100%;
  min-height: 44px;
  max-height: 180px;
  padding: 10px 0;
  overflow-y: auto;
  color: #111827;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.55;
  outline: none;
  border: 0;
  background: transparent;
  word-break: break-word;
  white-space: pre-wrap;
  cursor: text;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.message-input::-webkit-scrollbar {
  width: 5px;
}
.message-input::-webkit-scrollbar-track {
  background: transparent;
}
.message-input::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.message-input {
}
.message-input:empty::before {
  content: attr(data-placeholder);
  color: #9ca3af;
  font-size: 16px;
  font-weight: 400;
  pointer-events: none;
}
.message-input:focus:empty::before {
  color: #b1b8c5;
}
.actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  min-height: 44px;
}
.icon-btn,
.send-btn {
  position: relative;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 12px;
  cursor: pointer;
  transition:
    background-color 0.18s ease,
    transform 0.18s ease,
    box-shadow 0.18s ease,
    opacity 0.18s ease;
}
.icon-btn:focus-visible,
.send-btn:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.18);
  outline-offset: 2px;
}
.icon-btn:active,
.send-btn:active {
  transform: scale(0.94);
}
.icon-btn {
  background: #f4f6fa;
}
.icon-btn img {
  width: 21px;
  height: 21px;
  object-fit: contain;
  display: block;
}
.icon-btn:hover {
  background: #e9edf5;
  transform: translateY(-1px);
}
.icon-btn.mic:hover {
  background: #e8edf9;
}
.icon-btn.call:hover {
  background: #e8edf9;
}
.icon-btn.stop {
  background: #fff1f2;
}
.icon-btn.stop img {
  width: 20px;
  height: 20px;
}
.icon-btn.stop:hover {
  background: #ffe4e6;
}
.send-btn {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
}
.send-btn i {
  font-size: 17px;
  line-height: 1;
}
.send-btn {
}
.send-btn:disabled {
  opacity: 1;
  cursor: not-allowed;
  transform: none;
}
.send-btn {
}
.send-btn.active:not(:disabled) {
  background: #253b80;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(37, 59, 128, 0.22);
}
.send-btn.active:not(:disabled):hover {
  background: #344f91;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(37, 59, 128, 0.25);
}
.send-btn.active:not(:disabled):active {
  transform: scale(0.94);
}
.input-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
  margin: 9px 0 0;
  color: #6b7280;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
}
.input-hint i {
  margin-right: 2px;
  color: #9ca3af;
  font-size: 13px;
}
.input-hint kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 21px;
  padding: 1px 6px;
  color: #475569;
  font-family: inherit;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  background: #f1f5f9;
  border: 1px solid #dbe2ea;
  border-bottom-width: 2px;
  border-radius: 5px;
  box-shadow: none;
}
.chat-input-wrapper.voice-active .chat-input-container {
  border-color: #253b80;
  background: #fafbff;
}
:host ::ng-deep .small-tooltip .p-tooltip-text {
  padding: 6px 9px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  background: #111827;
  border-radius: 6px;
}
@media (max-width: 768px) {
  .chat-input-wrapper {
    padding: 0 12px 12px;
  }
  .chat-input-container {
    min-height: 64px;
    padding: 9px 9px 9px 15px;
    border-radius: 16px;
  }
  .message-input {
    min-height: 42px;
    font-size: 15px;
  }
  .message-input:empty::before {
    font-size: 15px;
  }
  .icon-btn,
  .send-btn {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
  }
  .icon-btn img {
    width: 20px;
    height: 20px;
  }
  .input-hint {
    font-size: 12px;
  }
}
@media (max-width: 576px) {
  .chat-input-wrapper {
    padding: 0 8px 10px;
  }
  .chat-input-container {
    min-height: 60px;
    padding: 8px 8px 8px 13px;
    gap: 5px;
    border-radius: 15px;
  }
  .message-input {
    min-height: 40px;
    max-height: 140px;
    padding: 9px 0;
    font-size: 15px;
    line-height: 1.45;
  }
  .message-input:empty::before {
    font-size: 15px;
  }
  .actions {
    gap: 3px;
  }
  .icon-btn,
  .send-btn {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    border-radius: 10px;
  }
  .icon-btn img {
    width: 18px;
    height: 18px;
  }
  .send-btn i {
    font-size: 15px;
  }
  .input-hint {
    gap: 4px;
    margin-top: 7px;
    font-size: 11px;
  }
  .input-hint kbd {
    min-height: 20px;
    padding: 1px 5px;
    font-size: 10px;
  }
}
@media (max-width: 400px) {
  .chat-input-container {
    padding-left: 11px;
  }
  .icon-btn,
  .send-btn {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .actions {
    gap: 2px;
  }
  .input-hint {
    font-size: 10.5px;
  }
  .input-hint i {
    font-size: 11px;
  }
}
.input-hint {
  margin-top: 12px;
  font-size: 13px;
  text-align: center;
  color: #94a3b8;
}
.input-hint kbd {
  padding: 2px 7px;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 12px;
  color: #9e9e9e;
}
.input-hint i {
  margin-right: 6px;
}
@media (max-width: 768px) {
  app-page-header {
    padding: 0 16px;
  }
  app-page-header .header-center {
    flex: initial;
  }
  app-page-header .query-toggle {
    transform: scale(0.9);
  }
  app-page-header .query-toggle.mobile-toggle {
    width: 100%;
  }
  .main {
    padding: 16px;
  }
  .empty-state .box {
    padding: 32px 24px;
  }
  .empty-state .box h2 {
    font-size: 26px;
  }
  .empty-state .box p {
    font-size: 15px;
  }
  .chat-input-container {
    padding: 12px;
  }
}
.doc-dropdown-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.document-action-btn {
  position: relative;
  width: 42px;
  height: 42px;
  border: 1px solid #e4e8f0;
  border-radius: 10px;
  background: #ffffff;
  color: #536079;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
}
.document-action-btn:hover {
  background: #f5f7fb;
  border-color: #cfd6e4;
  color: #253b80;
}
.document-action-btn:active {
  transform: scale(0.96);
}
.document-action-btn.active {
  background: #eef2ff;
  border-color: #c9d2f5;
  color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.document-action-btn .document-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.document-action-btn .document-icon i {
  font-size: 18px;
}
.document-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border: 2px solid #fff;
  border-radius: 20px;
  background: #253b80;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 2px 6px rgba(37, 59, 128, 0.22);
}
.doc-dropdown {
  position: absolute;
  z-index: 1100;
  top: calc(100% + 10px);
  right: 0;
  width: 390px;
  max-width: calc(100vw - 24px);
  max-height: 620px;
  background: #ffffff;
  border: 1px solid #e7eaf0;
  border-radius: 16px;
  box-shadow: 0 18px 45px rgba(24, 36, 58, 0.13), 0 4px 12px rgba(24, 36, 58, 0.06);
  overflow: hidden;
  animation: documentDropdownIn 0.18s ease-out;
  transform-origin: top right;
}
@keyframes documentDropdownIn {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.dropdown-header {
  min-height: 72px;
  padding: 15px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background:
    linear-gradient(
      135deg,
      #f7f9ff 0%,
      #ffffff 70%);
  border-bottom: 1px solid #edf0f5;
}
.dropdown-title {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}
.dropdown-title-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2ff;
  color: #253b80;
}
.dropdown-title-icon i {
  font-size: 17px;
}
.dropdown-title > div:last-child {
  min-width: 0;
}
.dropdown-title h4 {
  margin: 0 0 3px;
  color: #172033;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
}
.dropdown-title span {
  display: block;
  color: #7a8498;
  font-size: 11px;
  line-height: 1.3;
}
.dropdown-header .count {
  min-width: 30px;
  height: 28px;
  padding: 0 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f0f3f9;
  color: #536079;
  font-size: 12px;
  font-weight: 700;
}
.search-box {
  position: relative;
  margin: 12px 14px;
  height: 40px;
  display: flex;
  align-items: center;
  background: #f7f8fb;
  border: 1px solid #e6e9ef;
  border-radius: 10px;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;
}
.search-box:focus-within {
  background: #fff;
  border-color: #9daee0;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07);
}
.search-box > i {
  margin-left: 12px;
  color: #8993a7;
  font-size: 13px;
}
.search-box input {
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #263044;
  font-size: 12px;
}
.search-box input::placeholder {
  color: #9aa3b4;
}
.clear-search {
  width: 28px;
  height: 28px;
  margin-right: 5px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #8a94a6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease;
}
.clear-search:hover {
  background: #e9ecf2;
  color: #3f4a5e;
}
.clear-search i {
  font-size: 11px;
}
.dropdown-body {
  max-height: 450px;
  padding: 2px 8px 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cdd3df transparent;
}
.dropdown-body::-webkit-scrollbar {
  width: 5px;
}
.dropdown-body::-webkit-scrollbar-track {
  background: transparent;
}
.dropdown-body::-webkit-scrollbar-thumb {
  background: #d2d7e1;
  border-radius: 10px;
}
.doc-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 11px;
  margin: 3px 0;
  padding: 10px 8px;
  border: 1px solid transparent;
  border-radius: 11px;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    transform 0.18s ease;
}
.doc-item:hover {
  background: #f7f9fd;
  border-color: #e8ebf2;
}
.doc-item:hover .view-btn {
  opacity: 1;
  transform: translateX(0);
}
.doc-item:hover .doc-icon {
  background: #eef2ff;
  color: #253b80;
}
.doc-icon {
  width: 38px;
  height: 42px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff2f2;
  color: #dc4b4b;
  transition: background 0.18s ease, color 0.18s ease;
  position: relative;
}
.doc-icon::after {
  content: "";
  position: absolute;
  right: 5px;
  top: 5px;
  width: 7px;
  height: 7px;
  border-top: 1px solid currentColor;
  border-right: 1px solid currentColor;
  opacity: 0.25;
}
.doc-icon i {
  font-size: 18px;
}
.doc-content {
  flex: 1;
  min-width: 0;
  padding-right: 5px;
}
.doc-name {
  color: #273148;
  font-size: 13px !important;
  font-weight: 600;
  line-height: 1.45;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.18s ease;
  text-wrap: auto !important;
}
.doc-name:hover {
  color: #253b80;
}
.doc-type {
  display: block;
  margin-top: 3px;
  color: #929bad;
  font-size: 10px;
}
.view-btn {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border: 1px solid #e3e7ee;
  border-radius: 8px;
  background: #ffffff;
  color: #6d778b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transform: translateX(4px);
  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    background 0.18s ease,
    color 0.18s ease,
    border-color 0.18s ease;
}
.view-btn:hover {
  background: #253b80;
  border-color: #253b80;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(37, 59, 128, 0.18);
}
.view-btn i {
  font-size: 13px;
}
.empty-documents {
  min-height: 220px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #7d8799;
}
.empty-icon {
  width: 58px;
  height: 58px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #f4f6fa;
  color: #9aa4b6;
}
.empty-icon i {
  font-size: 24px;
}
.empty-documents strong {
  margin-bottom: 5px;
  color: #465166;
  font-size: 13px;
  font-weight: 700;
}
.empty-documents span {
  max-width: 230px;
  color: #929bad;
  font-size: 11px;
  line-height: 1.5;
}
@media (max-width: 576px) {
  .doc-dropdown {
    position: fixed;
    top: 62px;
    right: 12px;
    left: 12px;
    width: auto;
    max-width: none;
    max-height: calc(100vh - 80px);
    border-radius: 14px;
  }
  .dropdown-body {
    max-height: calc(100vh - 190px);
  }
  .view-btn {
    opacity: 1;
    transform: none;
  }
}
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  background: #fff;
  border: none;
  border-radius: 12px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.25s ease;
}
.icon-btn i {
  font-size: 1.15rem;
}
.icon-btn:hover {
  background: #f5f7fa;
  color: #111827;
  transform: translateY(-1px);
}
.doc-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 360px;
  max-height: 420px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.05);
  animation: dropdownFade 0.2s ease;
  z-index: 1000;
}
.dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
}
.dropdown-header .title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.dropdown-header .title i {
  font-size: 1rem;
  color: #3b82f6;
}
.dropdown-header .title span {
  font-size: 0.95rem;
  font-weight: 600;
  color: #111827;
}
.dropdown-header .count {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 0.75rem;
  background: #eff6ff;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--primary);
}
.dropdown-body {
  max-height: 300px;
  overflow-y: auto;
  padding: 0.75rem;
}
.doc-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
}
.doc-item .doc-content {
  flex: 1;
}
.doc-item .view-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s ease;
}
.doc-item .view-btn:hover {
  background: #f3f4f6;
}
.doc-item .view-btn i {
  font-size: 1rem;
  color: #4b5563;
}
.doc-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: #fef2f2;
  border-radius: 12px;
}
.doc-icon i {
  font-size: 1.2rem;
  color: #ef4444;
}
.doc-content {
  flex: 1;
  min-width: 0;
}
.doc-name {
  overflow: hidden;
  font-size: 13px;
  font-weight: 500 !important;
  color: #111827;
  text-overflow: ellipsis;
}
.doc-meta {
  margin-top: 0.25rem;
  font-size: 0.78rem;
  color: #9ca3af;
}
.remove-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 10px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
}
.remove-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}
@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #ececec;
  background: #fff;
}
.search-box i {
  color: #888;
  font-size: 14px;
}
.search-box input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
}
.search-box input::placeholder {
  color: #999;
}
.no-data {
  text-align: center;
  color: #999;
  padding: 20px;
  font-size: 14px;
}
.history-search {
  position: relative;
  margin: 16px;
}
.history-search i {
  position: absolute;
  top: 50%;
  left: 14px;
  color: #888;
  transform: translateY(-50%);
}
.history-search input {
  width: 100%;
  padding: 12px 14px 12px 40px;
  border: 1px solid #ddd;
  border-radius: 12px;
  font-size: 14px;
  outline: none;
}
.history-search input:focus {
  border-color: #6366f1;
}
.history-panel {
  position: fixed;
  top: 0;
  right: -380px;
  display: flex;
  flex-direction: column;
  width: 380px;
  height: 100vh;
  background: #fff;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.12);
  transition: right 0.3s ease;
  z-index: 1000;
}
.history-panel.open {
  right: 0;
}
.history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 20px;
  border-bottom: 1px solid #ececec;
}
.history-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.history-header .close-btn {
  background: transparent;
  border: none;
  font-size: 18px;
  cursor: pointer;
}
.history-body {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 0 16px 20px;
  box-sizing: border-box;
  scrollbar-width: thin;
}
.history-body::-webkit-scrollbar {
  width: 6px;
}
.history-body::-webkit-scrollbar-thumb {
  background: #cfcfcf;
  border-radius: 10px;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 18px 0 10px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #6b7280;
}
.section-title i {
  flex-shrink: 0;
}
.history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-width: 0;
  min-height: 58px;
  margin-bottom: 8px;
  padding: 10px 12px;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.history-item:hover {
  background: #f7f8fa;
}
.history-item:hover .item-actions {
  opacity: 1;
  visibility: visible;
}
.history-item.active {
  background: #eef2ff;
  border-color: #c7d2fe;
}
.item-left {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  gap: 12px;
  min-width: 0;
  overflow: hidden;
}
.item-left .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  background: #f3f4f6;
  border-radius: 10px;
  color: #6366f1;
}
.item-left .icon i {
  font-size: 16px;
}
.item-left .content {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}
.item-left .content .title {
  display: block;
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-left .content .date {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #9ca3af;
}
.item-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex: 0 0 auto;
  margin-left: auto;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease;
}
.item-actions .action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #6b7280;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.item-actions .action-btn i {
  font-size: 14px;
  line-height: 1;
}
.item-actions .action-btn:hover {
  background: #ececec;
}
.item-actions .action-btn.pin:hover {
  color: #f59e0b;
}
.item-actions .action-btn.delete:hover {
  background: #fee2e2;
  color: #ef4444;
}
.item-actions .action-btn:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 2px;
}
.history-item.pinned-item {
  background: #fff7e6;
}
.history-item.pinned-item:hover {
  background: #ffefcc;
}
.history-item.pinned-item .icon {
  background: #ffe0a3;
  color: #d97706;
}
.history-item.pinned-item .icon i,
.history-item.pinned-item .pin i {
  color: #d97706;
}
.history-item.pinned-item.active {
  background: #ffe8b3;
  border-color: #f59e0b;
}
@media (hover: none) {
  .item-actions {
    opacity: 1;
    visibility: visible;
  }
}
@media (max-width: 768px) {
  .history-panel {
    width: 100%;
    right: -100%;
  }
  .history-panel.open {
    right: 0;
  }
  .history-body {
    padding: 0 12px 16px;
  }
  .history-item {
    gap: 8px;
    padding: 9px;
  }
  .item-left {
    gap: 8px;
  }
}
@media (max-width: 480px) {
  .history-body {
    padding-right: 8px;
    padding-left: 8px;
  }
  .history-item {
    gap: 6px;
    padding: 8px;
  }
  .item-left {
    gap: 8px;
  }
  .item-left .icon {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
  }
  .item-left .content .title {
    font-size: 13px;
  }
  .item-actions {
    gap: 2px;
  }
  .item-actions .action-btn {
    width: 28px;
    height: 30px;
    flex-basis: 28px;
  }
}
.history-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}
::ng-deep .small-tooltip .p-tooltip-text {
  padding: 6px 10px;
  font-size: 11px;
  line-height: 1.2;
  max-width: 180px;
}
::ng-deep .small-tooltip .p-tooltip-arrow {
  transform: scale(0.8);
}
.document-container {
  display: flex;
  height: 80vh;
}
.viewer-section {
  position: relative;
  flex: 1;
  background: #f7f7f7;
}
.document-list {
  width: 280px;
  overflow-y: auto;
  background: #fff;
  border-left: 1px solid #e5e5e5;
}
.document-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f1;
  transition: all 0.2s ease;
}
.document-item:hover {
  background: #f5f7fb;
}
.document-item.active {
  background: #e8f0fe;
  border-left: 4px solid var(--primary);
  font-weight: 600;
}
.document-item.active .doc-name {
  color: var(--primary);
  font-weight: 600 !important;
}
.document-item.active .pi {
  color: #f5f7fb;
}
.document-item i {
  font-size: 22px;
  color: #253B80;
}
.doc-info {
  flex: 1;
}
.doc-name {
  font-weight: 600;
  word-break: break-word;
}
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
::ng-deep .document-popup .p-dialog {
  overflow: hidden;
  border-radius: 12px;
}
::ng-deep .document-popup .p-dialog-header {
  padding: 1rem 1.5rem;
  font-size: 12px;
  font-weight: 600;
}
::ng-deep .document-popup .p-dialog-title {
  font-size: 1rem;
}
::ng-deep .document-popup .p-dialog-content {
  height: calc(90vh - 60px);
  padding: 0;
  overflow: hidden;
}
::ng-deep .document-popup iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}
.document-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  padding: 3px 20px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
}
.document-footer .nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 140px;
  height: 44px;
  border: none;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}
.document-footer .nav-btn i {
  font-size: 16px;
}
.document-footer .nav-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}
.document-footer .nav-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.document-footer .prev-btn {
  background: #f3f4f6;
  color: #374151;
}
.document-footer .prev-btn:hover:not(:disabled) {
  background: #e5e7eb;
}
.document-footer .next-btn {
  background: var(--primary);
  color: #fff;
}
.document-footer .next-btn:hover:not(:disabled) {
  background: #253B80;
}
.document-footer .doc-counter {
  min-width: 90px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: #374151;
}
.document-footer .doc-counter span {
  margin: 0 6px;
  color: #9ca3af;
}
.p-dialog-footer {
  padding: 0 !important;
}
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 25%;
  gap: 1rem;
  color: #666;
}
.loader-container p {
  margin: 0;
  font-size: 14px;
}
::ng-deep .document-viewer-dialog {
  border: 0 !important;
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.22), 0 8px 25px rgba(15, 23, 42, 0.08);
}
::ng-deep .document-viewer-dialog .p-dialog-header {
  padding: 0 !important;
  border-bottom: 1px solid #e9eef5;
  background: #ffffff;
}
::ng-deep .document-viewer-dialog .p-dialog-content {
  padding: 0 !important;
  background: #f6f8fb;
}
::ng-deep .document-viewer-dialog .p-dialog-footer {
  padding: 0 !important;
  border-top: 1px solid #e9eef5;
  background: #ffffff;
}
::ng-deep .document-viewer-dialog .p-dialog-header-icons {
  margin-right: 18px;
}
::ng-deep .document-viewer-dialog .p-dialog-header-icons .p-dialog-header-icon {
  width: 34px;
  height: 34px;
  border: 1px solid #e5eaf1;
  border-radius: 8px;
  background: #f8fafc;
}
::ng-deep .document-viewer-dialog .p-dialog-header-icons .p-dialog-header-icon:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.doc-header {
  min-height: 76px;
  width: 100%;
  padding: 14px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background: #ffffff;
}
.doc-header-left {
  display: flex;
  align-items: center;
  gap: 13px;
  min-width: 0;
}
.doc-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #eef4ff;
  color: #253b80;
  font-size: 20px;
  flex-shrink: 0;
}
.doc-heading {
  min-width: 0;
}
.doc-heading h3 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.doc-meta {
  display: block;
  margin-top: 3px;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
}
.doc-header-right {
  display: flex;
  align-items: center;
}
.current-doc {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px 11px;
  border: 1px solid #e5eaf1;
  border-radius: 8px;
  background: #f8fafc;
}
.current-doc span {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 500;
}
.current-doc strong {
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}
.document-container {
  height: calc(92vh - 132px);
  min-height: 450px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 310px;
  background: #f6f8fb;
}
.viewer-section {
  position: relative;
  min-width: 0;
  min-height: 0;
  padding: 18px;
  display: flex;
  align-items: stretch;
  justify-content: center;
  background:
    radial-gradient(
      circle at center,
      rgba(37, 99, 235, 0.025),
      transparent 55%),
    #f6f8fb;
  overflow: hidden;
}
.document-preview {
  width: 100%;
  height: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.04);
}
.media-viewer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  overflow: hidden;
  background: #0f172a;
  box-shadow: 0 3px 15px rgba(15, 23, 42, 0.12);
}
.media-viewer vg-player {
  width: 100%;
  height: 100%;
}
.media-viewer video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #0f172a;
}
.loader-container {
  position: absolute;
  inset: 18px;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  text-align: center;
}
.loader-container .loader-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 50%;
  background: #eff6ff;
  color: #253b80;
  font-size: 21px;
}
.loader-container h4 {
  margin: 0;
  color: #1e293b;
  font-size: 14px;
  font-weight: 700;
}
.loader-container p {
  margin: 5px 0 0;
  color: #94a3b8;
  font-size: 12px;
}
.document-list {
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #e2e8f0;
  background: #ffffff;
}
.sidebar-header {
  min-height: 74px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #edf1f5;
}
.sidebar-label {
  display: block;
  margin-bottom: 3px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.9px;
}
.sidebar-header h4 {
  margin: 0;
  color: #1e293b;
  font-size: 14px;
  font-weight: 700;
}
.document-count {
  min-width: 28px;
  height: 28px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}
.documents-scroll {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.documents-scroll::-webkit-scrollbar {
  width: 5px;
}
.documents-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.documents-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.document-item {
  position: relative;
  min-height: 66px;
  margin-bottom: 6px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.document-item:hover {
  background: #f8fafc;
  border-color: #e5eaf1;
}
.document-item.active {
  background: #eff6ff;
  border-color: #bfdbfe;
}
.document-item.active .file-icon {
  background: #253b80;
  color: #253b80;
}
.document-item.active .doc-name {
  color: #253B80;
}
.file-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 15px;
  transition: all 0.2s ease;
}
.doc-info {
  min-width: 0;
  flex: 1;
}
.doc-name {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.doc-number {
  display: block;
  margin-top: 3px;
  color: #94a3b8;
  font-size: 10px;
}
.selected-icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: #253b80;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.25);
  animation: selectedCheck 0.2s ease-out;
}
.selected-icon i {
  font-size: 9px;
  font-weight: 700;
}
@keyframes selectedCheck {
  from {
    opacity: 0;
    transform: scale(0.7);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.document-action-btn {
  position: relative;
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5eaf1;
  border-radius: 10px;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.document-action-btn:hover {
  border-color: #bfdbfe;
  background: #f8fbff;
  color: #253b80;
  box-shadow: 0 3px 10px rgba(37, 99, 235, 0.08);
}
.document-action-btn:hover .document-icon {
  background: #eff6ff;
  color: #253b80;
}
.document-action-btn:active {
  transform: scale(0.95);
}
.document-action-btn.active {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
}
.document-action-btn.active .document-icon {
  background: #dbeafe;
  color: #253b80;
}
.document-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f1f5f9;
  color: #64748b;
  transition: background 0.2s ease, color 0.2s ease;
}
.document-icon i {
  font-size: 14px;
}
.document-badge {
  position: absolute;
  top: -4px;
  right: -5px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 20px;
  background: #253b80;
  color: #ffffff;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 2px 5px rgba(37, 99, 235, 0.25);
  z-index: 2;
}
.header-action-btn {
  position: relative;
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5eaf1;
  border-radius: 10px;
  background: #ffffff;
  color: #64748b;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.header-action-btn:active {
  transform: scale(0.95);
}
.header-action-btn .action-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f8fafc;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.header-action-btn .action-icon i {
  font-size: 14px;
}
.new-conversation-btn:hover {
  border-color: #bfdbfe;
  background: #f8fbff;
  color: #253b80;
  box-shadow: 0 3px 10px rgba(37, 99, 235, 0.08);
}
.new-conversation-btn:hover .action-icon {
  background: #eff6ff;
  color: #253b80;
  transform: rotate(45deg);
}
.new-conversation-btn:active .action-icon {
  transform: rotate(45deg) scale(0.92);
}
.history-btn:hover {
  border-color: #ddd6fe;
  background: #faf9ff;
  color: #7c3aed;
  box-shadow: 0 3px 10px rgba(124, 58, 237, 0.08);
}
.history-btn:hover .action-icon {
  background: #f5f3ff;
  color: #7c3aed;
}
@media (max-width: 767px) {
  .header-action-btn {
    width: 36px;
    height: 36px;
    border-radius: 9px;
  }
  .header-action-btn .action-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
  }
  .header-action-btn .action-icon i {
    font-size: 13px;
  }
}
.empty-documents {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #94a3b8;
}
.empty-documents i {
  margin-bottom: 10px;
  font-size: 28px;
}
.empty-documents p {
  margin: 0;
  font-size: 12px;
}
.time-divider {
  color: rgba(255, 255, 255, 0.6);
  margin: 0 4px;
}
.control-spacer {
  flex: 1;
}
#video-controls {
  display: block;
  width: 100%;
}
#seek-bar-container {
  width: 100%;
}
#seek-bar {
  position: relative;
  width: 100%;
}
#current-time {
  position: relative;
  width: 100%;
}
.bubles {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ffffff;
  transform: translateX(-50%);
}
.document-footer {
  min-height: 62px;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
}
.nav-btn {
  min-width: 100px;
  height: 38px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: #ffffff !important;
  color: #475569 !important;
  box-shadow: none !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  transition: all 0.2s ease;
}
.nav-btn:hover:not(:disabled) {
  border-color: #bfdbfe !important;
  background: #eff6ff !important;
  color: #253b80 !important;
}
.nav-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.nav-btn i {
  font-size: 13px;
}
.document-progress {
  display: flex;
  align-items: center;
  gap: 7px;
}
.document-progress .current {
  min-width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #eff6ff;
  color: #253b80;
  font-size: 12px;
  font-weight: 700;
}
.document-progress .separator {
  color: #cbd5e1;
  font-size: 11px;
}
.document-progress .total {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}
@media (max-width: 991px) {
  .document-viewer-dialog {
    width: 95vw !important;
    height: 94vh !important;
  }
  .document-container {
    grid-template-columns: minmax(0, 1fr) 250px;
  }
  .viewer-section {
    padding: 12px;
  }
  .sidebar-header {
    padding: 13px;
  }
  .document-item {
    padding: 8px;
  }
  .doc-name {
    font-size: 11px;
  }
}
@media (max-width: 767px) {
  .document-viewer-dialog {
    width: 96vw !important;
    height: 95vh !important;
  }
  .document-viewer-dialog .p-dialog-header-icons {
    margin-right: 8px;
  }
  .doc-header {
    min-height: 65px;
    padding: 10px 12px;
  }
  .doc-icon {
    width: 38px;
    height: 38px;
    font-size: 17px;
  }
  .doc-heading h3 {
    max-width: 180px;
    font-size: 14px;
  }
  .current-doc {
    display: none;
  }
  .document-container {
    height: calc(95vh - 127px);
    display: flex;
    flex-direction: column;
  }
  .viewer-section {
    height: 60%;
    min-height: 280px;
    flex-shrink: 0;
    padding: 10px;
  }
  .document-list {
    height: 40%;
    min-height: 160px;
    border-top: 1px solid #e2e8f0;
    border-left: 0;
  }
  .sidebar-header {
    min-height: 50px;
    padding: 9px 12px;
  }
  .sidebar-header h4 {
    font-size: 12px;
  }
  .documents-scroll {
    padding: 7px 10px;
  }
  .document-item {
    min-height: 55px;
    margin-bottom: 4px;
  }
  .file-icon {
    width: 32px;
    height: 32px;
  }
  .document-footer {
    min-height: 62px;
    padding: 9px 12px;
  }
  .nav-btn {
    min-width: 42px !important;
    height: 36px;
  }
  .nav-btn span {
    display: none;
  }
}
@media (max-width: 480px) {
  .doc-meta {
    font-size: 10px;
  }
  .doc-heading h3 {
    max-width: 145px;
  }
  .viewer-section {
    min-height: 240px;
  }
  .document-list {
    min-height: 145px;
  }
  .document-progress {
    gap: 5px;
  }
  .document-progress .current {
    width: 27px;
    min-width: 27px;
    height: 27px;
  }
}
.doc-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 1.5rem;
  background: rgba(255, 255, 255, 0.95);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid #ececec;
}
.doc-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 18px;
  font-weight: 600;
  color: #222;
}
.doc-title i {
  font-size: 20px;
  color: var(--primary);
}
.doc-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.document-body {
  height: 100%;
  overflow: auto;
  background: #f5f7fb;
}
.viewer {
  display: block;
  width: 100%;
  height: 100%;
}
.doc-container,
.excel-container,
.ppt-container {
  height: 100%;
  margin: 1rem;
  padding: 2rem;
  overflow: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.unsupported {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 1rem;
  text-align: center;
  color: #777;
}
.unsupported i {
  font-size: 60px;
  color: #ff9800;
}
.unsupported h3 {
  margin: 0;
  font-size: 22px;
}
@media (max-width: 768px) {
  :host ::ng-deep .document-viewer-dialog {
    width: 100vw !important;
    height: 100vh !important;
    border-radius: 0;
  }
  .doc-header {
    padding: 0 1rem;
  }
  .doc-title {
    font-size: 16px;
  }
}
.voice-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
}
.mic-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: var(--primary);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.25s ease;
}
.mic-btn i {
  font-size: 24px;
  line-height: 1;
}
.mic-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(21, 101, 192, 0.25);
}
.mic-btn:active:not(:disabled) {
  transform: scale(0.95);
}
.mic-btn.active {
  animation: micPulse 1.5s infinite;
}
.mic-btn.muted {
  background: #ef4444;
}
.mic-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}
.connect-btn,
.disconnect-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 130px;
  height: 46px;
  padding: 0 22px;
  border: none;
  border-radius: 30px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}
.connect-btn:hover:not(:disabled),
.disconnect-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}
.connect-btn:active:not(:disabled),
.disconnect-btn:active:not(:disabled) {
  transform: scale(0.97);
}
.connect-btn:disabled,
.disconnect-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.connect-btn {
  background: #22c55e;
}
.connect-btn:hover:not(:disabled) {
  background: #16a34a;
}
.disconnect-btn {
  background: #ef4444;
}
.disconnect-btn:hover:not(:disabled) {
  background: #dc2626;
}
@keyframes micPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.45);
  }
  70% {
    box-shadow: 0 0 0 18px rgba(37, 99, 235, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
  }
}
.chat-input {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding: 16px 20px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
}
.chat-input input {
  flex: 1;
  height: 48px;
  padding: 0 18px;
  border: 1px solid #d1d5db;
  border-radius: 30px;
  font-size: 14px;
  color: #374151;
  outline: none;
  transition: all 0.25s ease;
}
.chat-input input::placeholder {
  color: #9ca3af;
}
.chat-input input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.12);
}
.chat-input input:disabled {
  background: #f3f4f6;
  opacity: 0.7;
  cursor: not-allowed;
}
.chat-input button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--primary);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.25s ease;
}
.chat-input button i {
  font-size: 18px;
  line-height: 1;
}
.chat-input button:hover:not(:disabled) {
  background: #0d47a1;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(21, 101, 192, 0.25);
}
.chat-input button:active:not(:disabled) {
  transform: scale(0.95);
}
.chat-input button:disabled {
  background: #cbd5e1;
  opacity: 0.7;
  cursor: not-allowed;
  box-shadow: none;
}
@media (max-width: 768px) {
  .voice-controls {
    gap: 12px;
    padding: 16px;
  }
  .mic-btn {
    width: 56px;
    height: 56px;
  }
  .mic-btn i {
    font-size: 20px;
  }
  .connect-btn,
  .disconnect-btn {
    min-width: 110px;
    height: 42px;
    font-size: 13px;
  }
  .chat-input {
    padding: 14px 16px;
  }
  .chat-input input {
    height: 44px;
  }
  .chat-input button {
    width: 44px;
    height: 44px;
  }
}
@media (max-width: 576px) {
  .voice-controls {
    flex-direction: column;
  }
  .connect-btn,
  .disconnect-btn {
    width: 100%;
    max-width: 260px;
  }
}
.transcript-container {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 24px;
  background: #fafafa;
  scroll-behavior: smooth;
}
.transcript-container::-webkit-scrollbar {
  width: 6px;
}
.transcript-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.transcript-container::-webkit-scrollbar-track {
  background: transparent;
}
.message {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}
.message.user {
  align-items: flex-end;
  justify-content: flex-end;
}
.message.user .message-heading {
  color: #1565c0;
  text-align: right;
}
.message.agent {
  align-items: flex-start;
  justify-content: flex-start;
}
.message.agent .message-heading {
  color: #10b981;
  text-align: left;
}
.message-heading {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.bubble {
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 12px;
  background: #f3f4f6;
  word-break: break-word;
}
.message.user .bubble {
  background: #1565c0;
}
.message.agent .bubble {
  background: #f3f4f6;
}
.typing {
  margin-left: 2px;
  animation: blink 1s infinite;
}
@keyframes blink {
  50% {
    opacity: 0;
  }
}
.bubble {
  max-width: 75%;
  padding: 14px 18px;
  border-radius: 22px;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}
.user .bubble {
  background: var(--primary);
  color: #fff;
}
.agent .bubble {
  background: #fff;
  border: 1px solid #e6e6e6;
  color: #333;
}
.transcript-empty-state,
.empty-state {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  text-align: center;
}
.transcript-empty-state {
  min-height: 408px;
  height: 100%;
}
.pulse-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  color: #fff;
  font-size: 34px;
  animation: avatarPulse 1.8s infinite;
}
@keyframes avatarPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.4);
  }
  70% {
    box-shadow: 0 0 0 25px rgba(37, 99, 235, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 18px;
  background: #fff;
  border-top: 1px solid #ececec;
}
.control-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background: #f4f4f4;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.25s ease;
}
.control-btn i {
  font-size: 20px;
}
.control-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}
.control-btn:active:not(:disabled) {
  transform: scale(0.95);
}
.control-btn.active {
  background: var(--primary);
  color: #fff;
}
.control-btn.muted {
  background: #ef4444;
  color: #fff;
}
.control-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
@media (max-width: 768px) {
  .chat-input {
    gap: 10px;
    padding: 14px 16px;
  }
  .chat-input input {
    height: 44px;
    font-size: 13px;
  }
  .chat-input button {
    width: 44px;
    height: 44px;
  }
  .chat-input button i {
    font-size: 16px;
  }
  .bubble {
    max-width: 85%;
    font-size: 13px;
  }
  .footer {
    gap: 12px;
    padding: 16px;
  }
  .control-btn {
    width: 48px;
    height: 48px;
  }
  .control-btn i {
    font-size: 18px;
  }
}
@media (max-width: 576px) {
  .chat-input {
    padding: 12px;
  }
  .chat-input input {
    height: 42px;
    padding: 0 14px;
    font-size: 13px;
  }
  .chat-input button {
    width: 42px;
    height: 42px;
  }
  .chat-input button i {
    font-size: 15px;
  }
  .bubble {
    max-width: 92%;
  }
  .footer {
    gap: 10px;
    padding: 14px;
  }
  .control-btn {
    width: 44px;
    height: 44px;
  }
  .control-btn i {
    font-size: 16px;
  }
}
.session-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 160px;
  height: 52px;
  padding: 0 24px;
  background: #22c55e;
  border: none;
  border-radius: 32px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}
.session-btn i {
  font-size: 18px;
}
.session-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}
.session-btn:active:not(:disabled) {
  transform: scale(0.97);
}
.session-btn.connected {
  background: #ef4444;
}
.session-btn.connecting {
  background: #f59e0b;
}
.session-btn:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}
.text-input {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 96%;
  padding: 12px 12px 12px 2px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #dcdcdc;
  text-align: center;
  margin: auto 15px 10px;
}
.text-input input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  padding: 8px;
}
.text-input button {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 50%;
  background: #4f46e5;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text-input button:hover {
  background: #4338ca;
}
.text-input button i {
  font-size: 18px;
}
.text-input-container {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding: 16px 20px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
}
.text-input-container input {
  flex: 1;
  height: 48px;
  padding: 0 16px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 24px;
  color: #374151;
  font-size: 14px;
  outline: none;
  transition: all 0.25s ease;
}
.text-input-container input::placeholder {
  color: #9ca3af;
}
.text-input-container input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.15);
}
.text-input-container input:disabled {
  background: #f3f4f6;
  opacity: 0.7;
  cursor: not-allowed;
}
.text-input-container .send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--primary);
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.25s ease;
}
.text-input-container .send-btn i {
  font-size: 18px;
  line-height: 1;
}
.text-input-container .send-btn:hover:not(:disabled) {
  background: #0d47a1;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(21, 101, 192, 0.25);
}
.text-input-container .send-btn:active:not(:disabled) {
  transform: scale(0.95);
}
.text-input-container .send-btn:disabled {
  background: #cbd5e1;
  opacity: 0.7;
  cursor: not-allowed;
  box-shadow: none;
}
.video-call-layout {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  max-width: 300px;
  height: calc(100vh - 120px);
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}
.video-card {
  position: relative;
  flex: 1;
  overflow: hidden;
  background: #eaecf3;
  border-radius: 20px;
}
.video-card video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.agent-video {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 252px;
}
.agent-video img {
  object-fit: cover;
  z-index: 2;
}
.video-title {
  position: absolute;
  left: 16px;
  bottom: 16px;
  padding: 6px 14px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  z-index: 3;
}
.speaking-ring {
  position: absolute;
  width: 165px;
  height: 165px;
  border: 4px solid #4f9cff;
  border-radius: 50%;
  animation: speakingPulse 1.4s infinite;
}
@keyframes speakingPulse {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 0;
    transform: scale(1.25);
  }
}
.voice-footer {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.circle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  background: #eef2ff;
  cursor: pointer;
  transition: 0.25s ease;
}
.circle-btn i {
  font-size: 22px;
  color: #4b5563;
}
.circle-btn img {
  width: 28px;
  height: 28px;
}
.circle-btn:hover {
  background: #1565C0;
}
.circle-btn:hover i {
  color: #fff;
}
.circle-btn:hover img {
  filter: brightness(0) invert(1);
}
.circle-btn.active {
  background: #1565C0;
}
.circle-btn.active i {
  color: #fff;
}
.circle-btn.active img {
  filter: brightness(0) invert(1);
}
.call-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 180px;
  height: 56px;
  border: none;
  border-radius: 30px;
  background: #16a34a;
  color: #fff;
  cursor: pointer;
  transition: 0.25s ease;
}
.call-btn i {
  font-size: 18px;
}
.call-btn span {
  font-size: 15px;
  font-weight: 600;
}
.call-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.call-btn.connected {
  background: #dc2626;
}
.call-btn.connecting {
  background: #f59e0b;
}
.call-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.footer-controls {
  display: flex;
  align-items: center;
  gap: 18px;
}
.circle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  background: #f4f7fb;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.25s ease;
}
.circle-btn i {
  font-size: 22px;
  color: #5c6470;
}
.circle-btn img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.circle-btn:hover:not(:disabled) {
  background: #1565c0;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
}
.circle-btn:hover:not(:disabled) i {
  color: #fff;
}
.circle-btn:hover:not(:disabled) img {
  filter: brightness(0) invert(1);
}
.circle-btn:active:not(:disabled) {
  background: #ef4444;
  transform: scale(0.95);
}
.circle-btn.active {
  background: #1565c0;
}
.circle-btn.active i {
  color: #fff;
}
.circle-btn.active img {
  filter: brightness(0) invert(1);
}
.circle-btn.muted {
  background: #ffe9e9;
}
.circle-btn.muted i {
  color: #ef4444;
}
.circle-btn.muted img {
  opacity: 0.45;
}
.circle-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .transcript-container {
    padding: 16px;
  }
  .bubble {
    max-width: 90%;
    font-size: 13px;
  }
  .footer,
  .voice-footer {
    gap: 12px;
    padding: 16px;
    flex-wrap: wrap;
  }
  .control-btn {
    width: 48px;
    height: 48px;
  }
  .session-btn {
    min-width: 140px;
    height: 48px;
    font-size: 14px;
  }
  .pulse-circle {
    width: 72px;
    height: 72px;
    font-size: 28px;
  }
  .text-input-container {
    gap: 10px;
    padding: 14px 16px;
  }
  .text-input-container input {
    height: 44px;
    font-size: 13px;
  }
  .text-input-container .send-btn {
    width: 44px;
    height: 44px;
  }
  .text-input-container .send-btn i {
    font-size: 16px;
  }
  .circle-btn {
    width: 52px;
    height: 52px;
  }
  .circle-btn i {
    font-size: 20px;
  }
  .circle-btn img {
    width: 24px;
    height: 24px;
  }
}
@media (max-width: 576px) {
  .footer,
  .voice-footer {
    flex-direction: column;
  }
  .session-btn {
    width: 100%;
    max-width: 280px;
  }
  .bubble {
    max-width: 95%;
  }
  .text-input-container {
    padding: 12px;
  }
  .text-input-container input {
    height: 42px;
    padding: 0 14px;
    font-size: 13px;
  }
  .text-input-container .send-btn {
    width: 42px;
    height: 42px;
  }
  .text-input-container .send-btn i {
    font-size: 15px;
  }
  .circle-btn {
    width: 48px;
    height: 48px;
  }
  .circle-btn i {
    font-size: 18px;
  }
  .circle-btn img {
    width: 22px;
    height: 22px;
  }
}
.avatar-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 320px;
  transform: translate(-50%, -50%);
  transition: all 0.4s ease;
}
.avatar-container.minimized {
  top: auto;
  left: 20px;
  bottom: 20px;
  width: 120px;
  transform: none;
}
.agent-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
}
.agent-popup {
  width: 900px;
  height: 590px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.agent-popup.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important;
  max-height: none !important;
  border-radius: 0;
  margin: 0;
}
.popup-header {
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #ddd;
}
.agent-info {
  display: flex;
  align-items: center;
  gap: 16px;
}
.logo {
  width: 48px;
}
.status {
  font-size: 13px;
  color: #22c55e;
}
.popup-body {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.left-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition:
    top 0.7s ease,
    left 0.7s ease,
    transform 0.7s ease;
  z-index: 5;
}
.popup-body.connected .left-panel {
  top: 20px;
  left: 20px;
  transform: translate(0, 0);
}
.popup-body.connected .chat-panel {
  margin-left: 260px;
  width: calc(100% - 260px);
}
.avatar-card {
  width: 220px;
  height: 270px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  transition: 0.7s ease;
}
.popup-body.connected .avatar-card {
  width: 220px;
  height: 270px;
}
.avatar-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatar-status {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 14px;
}
.chat-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  min-height: 0;
}
.transcript-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  padding: 16px;
}
.text-input {
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .agent-popup {
    width: 100%;
    height: 100vh;
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }
  .popup-body {
    flex-direction: column;
  }
  .left-panel {
    width: 100%;
    min-height: 240px;
  }
  .avatar-card img {
    width: 150px;
  }
  .popup-header {
    padding: 0 16px;
  }
  .avatar-status {
    font-size: 16px;
  }
}
@media (max-width: 576px) {
  .avatar-container {
    width: 240px;
  }
  .avatar-container.minimized {
    width: 90px;
    left: 12px;
    bottom: 12px;
  }
  .left-panel {
    min-height: 200px;
    padding: 16px;
  }
  .avatar-card img {
    width: 120px;
  }
  .popup-header {
    height: 60px;
  }
  .logo {
    width: 40px;
  }
  .status {
    font-size: 12px;
  }
}
@keyframes listening {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes speaking {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.05);
  }
}
@media (max-width: 768px) {
  .popup-body {
    flex-direction: column;
  }
  .left-panel {
    width: 100%;
    height: 250px;
  }
  .avatar-card img {
    width: 150px;
  }
}
.ai-agent-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.ai-agent-popup {
  width: 900px;
  max-width: 100vw;
  height: 600px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.25);
  animation: popupScale 0.25s ease;
}
.ai-agent-popup.fullscreen {
  width: 100%;
  height: 100%;
  border-radius: 0;
}
.ai-popup-header {
  height: 72px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eef2f7;
  background: #fff;
}
.ai-agent-info {
  display: flex;
  align-items: center;
  gap: 14px;
}
.logo {
  width: 46px;
  height: 46px;
}
.ai-agent-info h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.status {
  font-size: 13px;
  color: #6b7280;
}
.actions {
  display: flex;
  gap: 10px;
}
.icon-btn {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 50%;
  background: #f5f7fb;
  cursor: pointer;
  transition: 0.25s;
}
.icon-btn:hover {
  background: #1565c0;
  color: #fff;
}
.ai-popup-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background:
    linear-gradient(
      180deg,
      #f8fafc 0%,
      #eef4ff 100%);
}
.ai-avatar-section {
  display: flex;
  justify-content: center;
  padding: 28px 20px 15px;
  animation: avatarMove 0.4s ease;
}
.ai-avatar-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.avatar-img {
  width: 250px;
  height: 250px;
  object-fit: cover;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 15px 45px rgba(37, 99, 235, 0.15);
  transition: 0.35s;
}
.ai-avatar-card.speaking .avatar-img {
  transform: scale(1.05);
}
.ai-avatar-card.listening .avatar-img {
  animation: pulse 1.4s infinite;
}
.avatar-status {
  margin-top: 16px;
  padding: 8px 18px;
  border-radius: 30px;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  color: #1565c0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}
.ai-chat-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.ai-transcript-container {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}
.ai-transcript-container::-webkit-scrollbar {
  width: 6px;
}
.ai-transcript-container::-webkit-scrollbar-thumb {
  background: #d6dbe5;
  border-radius: 20px;
}
.transcript-empty-state {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #94a3b8;
}
.transcript-empty-state img {
  width: 90px;
  margin-bottom: 20px;
}
.transcript-empty-state p {
  font-size: 16px;
}
.message {
  display: flex;
  align-items: flex-end;
  margin-bottom: 18px;
  width: 100%;
}
.message.agent {
  justify-content: flex-start;
}
.message.agent .message-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
}
.message.agent .message-content {
  max-width: 70%;
}
.message.agent .ai-message-heading {
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
}
.message.agent .ai-bubble {
  background: #ffffff;
  color: #1f2937;
  border-radius: 18px 18px 18px 6px;
  padding: 14px 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.message.user {
  justify-content: flex-end;
}
.message.user .message-content {
  max-width: 70%;
  order: 1;
}
.message.user .message-avatar {
  order: 2;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin-left: 12px;
  flex-shrink: 0;
}
.message.user .ai-message-heading {
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
}
.message.user .ai-bubble {
  background:
    linear-gradient(
      135deg,
      #1565c0,
      #3b82f6);
  color: white;
  border-radius: 18px 18px 6px 18px;
  padding: 14px 18px;
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.25);
}
.ai-bubble {
  word-break: break-word;
  line-height: 1.6;
  font-size: 14px;
}
.typing {
  margin-left: 4px;
  animation: blink 0.8s infinite;
}
@keyframes blink {
  50% {
    opacity: 0;
  }
}
.ai-text-input {
  padding: 18px;
  border-top: 1px solid #edf2f7;
  background: #fff;
  display: flex;
  gap: 12px;
}
.ai-text-input input {
  flex: 1;
  border: none;
  outline: none;
  height: 52px;
  padding: 0 20px;
  border-radius: 30px;
  background: #f4f6fb;
  font-size: 15px;
}
.ai-text-input button {
  width: 52px;
  height: 52px;
  border: none;
  border-radius: 50%;
  background: #1565c0;
  color: #fff;
  cursor: pointer;
  transition: 0.25s;
}
.ai-text-input button:hover {
  transform: scale(1.08);
}
.ai-agent-footer {
  height: 76px;
  border-top: 1px solid #edf2f7;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
}
.circle-btn {
  width: 52px;
  height: 52px;
  border: none;
  border-radius: 50%;
  background: #f4f6fb;
  cursor: pointer;
  transition: 0.25s;
}
.circle-btn img {
  width: 24px;
}
.circle-btn:hover {
  background: #1565c0;
  color: #fff;
}
.circle-btn.active {
  background: #1565c0;
  color: #fff;
}
.call-btn {
  min-width: 180px;
  height: 52px;
  border: none;
  border-radius: 30px;
  background: #22c55e;
  color: #fff;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: 0.25s;
}
.call-btn.connected {
  background: #ef4444;
}
.call-btn.connecting {
  background: #f59e0b;
}
@keyframes popupScale {
  from {
    transform: scale(0.92);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes avatarMove {
  from {
    transform: translateY(-25px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 rgba(37, 99, 235, 0.25);
  }
  50% {
    transform: scale(1.06);
    box-shadow: 0 0 30px rgba(37, 99, 235, 0.35);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 rgba(37, 99, 235, 0.25);
  }
}
@keyframes blink {
  50% {
    opacity: 0;
  }
}
@media (max-width: 768px) {
  .ai-agent-popup {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
  .avatar-img {
    width: 130px;
    height: 130px;
  }
  .message-content {
    max-width: 85%;
  }
  .call-btn {
    min-width: 140px;
  }
  .ai-popup-header {
    padding: 0 16px;
  }
  .ai-transcript-container {
    padding: 16px;
  }
}
/*# sourceMappingURL=ask-question.component.css.map */
